import { Typography, Modal, Card, Button, Grid, Fab, CardContent, CardMedia, CardActionArea, Radio }from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PianoOutlinedIcon from '@mui/icons-material/PianoOutlined';
import KeyboardBackspaceTwoToneIcon from '@mui/icons-material/KeyboardBackspaceTwoTone';
import './styles.css';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import violinButtonIcon from './violinButtonIcon2.png'

const FlashCardsBeginModal = (props) => {
	const {isBeginModalOpen, 
		convertChosenStackToData, 
		chosenFlashCardsData, 
		setChosenFlashCardsData, 
		setIsBeginModalOpen, 
		stackOptions,
		pathname
	} = props;
	const [chosenStackArr, setChosenStackArr] = useState([]);
	const [isStep2, setIsStep2] = useState(false);
	let navigate = useNavigate();

	const flashCardsSelectionMode = pathname.replace('/flashcards/for_', '') === 'piano' ? 'Piano' : 'Violin'

	const handlStackButtonClick = (id) => {
		if(!chosenStackArr.includes(id)) {
			setChosenStackArr([...chosenStackArr, id])
		} else {
			const newArr = chosenStackArr.filter(item => item !== id)
			setChosenStackArr(newArr)
		}
	}

	const handleClickAll = () => {
		if(chosenStackArr.length === stackOptions.length) {
			setChosenStackArr([]);
		} else {
			const allStackOptionIds = stackOptions.map(option => option.stackId)
			setChosenStackArr(allStackOptionIds)
		}
	}

	const handleRefresh = () => {
		setChosenFlashCardsData([]);
		setChosenStackArr([]);
		setIsStep2(false);
	}

	const handleNextStep = (chosenStackArr) => {
		convertChosenStackToData(chosenStackArr)
		setIsStep2(true)
	}
	
	const handleBeginSession = () => {
		setIsBeginModalOpen(false)
		setChosenStackArr([]);
		setIsStep2(false)
	}

  return (
		<Modal open={isBeginModalOpen}>
			<Card 
				className='modalCard' 
				style={{
					borderRadius: '15px',
					minWidth: '250px', 
					overflowY: 'auto', 
					maxHeight: '80vh', 
					backgroundColor: ' #f5f3ef' // lightbeige color
				}}>	
				<Grid container direction="column" spacing={2}>
				{!isStep2 ? 
					<>
						<Grid justifyContent="flex-end" direction="row" container>
							<Fab color="extended" id="flashCardModalIconButtons" aria-label="refresh" size='small' onClick={() => navigate(-1)}>
								<KeyboardBackspaceTwoToneIcon />
							</Fab>
							<Fab 
								color="extended" 
								id="flashCardModalIconButtons" 
								size='small' 
								onClick={() => navigate(flashCardsSelectionMode === 'Violin' ? '/flashcards/for_piano' : '/flashcards/for_violin')}
							>
								{flashCardsSelectionMode === 'Violin' ? <PianoOutlinedIcon /> : 
									<img 
										src={violinButtonIcon}
										style={{maxHeight: '30px'}}		
										alt='violin'
									/>
								}
							</Fab>
							<Fab color="extended" id="flashCardModalIconButtons" aria-label="refresh" size='small' onClick={() => navigate('/')}>
								<HomeOutlinedIcon />
							</Fab>
            			</Grid>
						<Grid item>
							<Typography  variant="h6" >
								Set up your own stack of {flashCardsSelectionMode} Flashcards!
							</Typography>
							
						</Grid>
						
						<Grid item>
							<Typography variant="body1">
								Please pick what you want to include in your stack of cards and then click the <strong>NEXT</strong> button below. You can choose more than one option!
							</Typography>
						</Grid>
						<Grid item container spacing={2}>
							<Grid item xs={12} md={6} xl={4} >
								<Button 
									style={{boxShadow: '0 10px 20px 0 #666666', height: '100%', borderRadius:'15px', maxWidth: '350px' }}
									fullWidth 
									variant="contained" 
									color={chosenStackArr.length === stackOptions.length ? 'secondary' : 'inherit'} 
									onClick={handleClickAll}
								>
									<Radio
										checked={chosenStackArr.length === stackOptions.length}
										onChange={
											handleClickAll}
										color="default" 
									/>	
									<Typography variant="h6" style={{color: chosenStackArr.length === stackOptions.length  ? ' #ffffff' : ' #000000'}}>
										All notes
									</Typography>
								</Button>
							</Grid>
							{stackOptions.map(stack => (
								<Grid item xs={12} md={6} xl={4} key={stack.stackId}>
									<Card sx={{ maxWidth: '350px' }} style={{boxShadow: '0 10px 20px 0 #666666', borderRadius:'15px' }}>
										<CardActionArea onClick={() => handlStackButtonClick(stack.stackId)} >
											<CardMedia
												component="img"
												height="140"
												image={stack.stackPhoto}
												alt={stack.stackName}
											/>
											<CardContent style={{background: !!chosenStackArr.includes(stack.stackId) ? 'linear-gradient(60deg, #9c27b0, #e6e6e6)' : ' #ffffff'}}>	
											<Grid container direction='row' alignItems='center'>
												<Grid item>
													<Radio
														checked={!!chosenStackArr.includes(stack.stackId)}
														onChange={() => handlStackButtonClick(stack.stackId)}
														color="default" 
													/>	
												</Grid>
												<Grid item>
													<Typography variant="h6" style={{color: !!chosenStackArr.includes(stack.stackId) ? ' #ffffff' : ' #000000'}}>
														{stack.stackName}
													</Typography>
												</Grid>
											</Grid>
												<Typography variant="body2" color={!!chosenStackArr.includes(stack.stackId) ? 'text.secondary' : "text.secondary"}>{stack.stackDescription}</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</Grid>
							))}
						</Grid>
							<Grid item container justifyContent='flex-end'>
								<Button 
									id="modalButton" 
									variant="contained" 
									color="secondary"
									disabled={chosenStackArr.length === 0}
									onClick={() => handleNextStep(chosenStackArr)}
								>Next</Button>
							</Grid>				
					</>
					:
					<>
						<Grid justifyContent="flex-end" direction="row" container>
                <Fab color="extended" id="flashCardModalIconButtons" aria-label="refresh" size='small' onClick={() => handleRefresh()}>
                  <RefreshIcon />
                </Fab>
            </Grid>
						<Grid item>
							<Typography  variant="h6" >
								You have chosen your stack of Flashcards!
							</Typography>
						</Grid>
						<Grid item>
							<Typography variant="body1">
								Your chosen stack has <strong>{chosenFlashCardsData.length/2}</strong> notes and each note will appear twice, which makes up total of <strong>{chosenFlashCardsData.length}</strong> questions in random order.
							</Typography>
						</Grid>
						<Grid item>
							<Typography variant="body1">
								Please try to answer them as <strong>quickly</strong> as possible as you will be timed!
							</Typography>
						</Grid>
						<Grid item>
							<Typography variant="body1">
								Be careful! Any wrong answer may delay you and you will be asked to do those questions <strong style={{color: ' #b30000'}}>again</strong> at the end of the round!
							</Typography>
						</Grid>
						<Grid item>
							<Typography variant="body1">
								The timer will start when you click the <strong>START</strong> button. Are you ready? 
							</Typography>
						</Grid>
						<Grid item container justifyContent='flex-end'>
							<Button 
								id="modalButton" 
								variant="contained" 
								color="secondary"
								onClick={handleBeginSession}
							>Start</Button>
						</Grid>
					</>
				}
				</Grid>
			</Card>
		</Modal>
	)
}

export default FlashCardsBeginModal;